import React from 'react';
import { PinnedListingPicker } from '../shared/PinnedListingPicker';
import { Wrapper } from '../Wrapper';

// Attribute panel for the Listing Wrapper. It IS a wrapper, so it gets the
// wrapper's own controls (background, padding, border) with the listing picker
// added on top — no bespoke stripped-down panel.
//
// No AttributesPanelWrapper here: the Wrapper panel's CollapseWrapper already
// renders one, and nesting a second produced a duplicate "…Attributes" header.
export const CustomListing: React.FC<{ nodePath?: string }> = () => (
	<Wrapper listingSettings={<PinnedListingPicker />} />
);
